import { defineStore } from 'pinia'

export const useMapSettingsStore = defineStore('mapSettingsStore', {
  state: () => ({
    showScanRange: false,
    enableMouseWheelZoom: false,
    hideBackgroundImage: false,
    rememberTooltipPosition: false,
    showAllShipActionPaths: true,
    showLargeFleets: true,
    showTerritoryOverlay: false,
    territoryOpacity: 20
  }),
  getters: {},
  actions: {
    setShowScanRange(value: boolean) {
      this.showScanRange = value
    },
    setEnableMouseWheelZoom(value: boolean) {
      this.enableMouseWheelZoom = value
    },
    setHideBackgroundImage(value: boolean) {
      this.hideBackgroundImage = value
    },
    setRememberTooltipPosition(value: boolean) {
      this.rememberTooltipPosition = value
    },
    setShowAllShipActionPaths(value: boolean) {
      this.showAllShipActionPaths = value
    },
    setShowLargeFleets(value: boolean) {
      this.showLargeFleets = value
    },
    toggleTerritoryOverlay() {
      this.showTerritoryOverlay = !this.showTerritoryOverlay
    }
  },
  persist: {
    key: 'mapSettingsStore',
    storage: localStorage,
    serializer: {
      serialize: (state) => {
        // Deep clone using JSON
        const cloned = JSON.parse(JSON.stringify(state))

        return JSON.stringify(cloned)
      },
      deserialize: (value) => JSON.parse(value)
    }
  }
})
